'use strict';

var BannerExpansive = {
  toggle: function toggle(event) {
    event.preventDefault();
    $(this).toggleClass('is-open');
  }
};

$('.js-banner-expansive').on('click tap', BannerExpansive.toggle);
